<template>
  <VDialogV3
    ref="dialog"
    id="demand-v2-request-dialog"
    width="400px"
    class="demand-create-request-dialog"
    :entity="localRequest"
    :title="title"
    :submit-method="submit"
  >
    <DemandRequestCreateForm
      :request="localRequest"
    />

    <template #footer>
      <VButton
        theme="primary"
        @click="$refs.dialog.submit()"
      >
        Сохранить
      </VButton>
      <VButton @click="$core.dialogs.DemandV2RequestDialog.hide()">
        Закрыть
      </VButton>
    </template>
  </VDialogV3>
</template>

<script lang="ts">

import DemandRequest           from '@/domains/DemandsV2/DemandRequest';
import DemandsV2Service        from '@/domains/DemandsV2/DemandsV2Service';

import DemandRequestCreateForm from '@/domains/DemandsV2/components/DemandV2Card/DemandV2RequestDialog/DemandRequestCreateForm.vue';

export default defineComponent({
  name: 'DemandV2RequestDialog',

  components: { DemandRequestCreateForm },

  props: {
    request: {
      type:    DemandRequest,
      default: null,
    },
  },

  data() {
    return {
      /** cloneDeep потому что я не хочу чтобы потребность смутировала */
      localRequest: this.$core.utils.cloneDeep(this.request) as DemandRequest,
    };
  },

  computed: {
    title(): string {
      if (this.localRequest.isExisting === true) {
        return 'Редактирование заявки';
      }
      else {
        return 'Создание заявки';
      }
    },
  },

  methods: {
    async submit(): Promise<boolean> {
      if (this.localRequest.isExisting === true) {
        return await DemandsV2Service.updateRequest(this.localRequest);
      }
      else {
        return await DemandsV2Service.addRequest(this.localRequest);
      }
    },
  },
});
</script>